export interface IAddressesResponse {
  count: number;
  next: null | string;
  previous: null | string;
  results: IAddress[];
}

export type AddressType = 'BILLING' | 'SHIPPING';

export interface IAddress {
  id: number;
  address_type: AddressType;
  full_name: string;
  email: string;
  phone_number: string;
  address_line_1: string;
  address_line_2?: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  extra_description: string;
  created_at: string;
  is_default: boolean;
  customer: number;
}

export interface IAddAddressPostRequestPayload {
  address_type: AddressType;
  body: {
    full_name: string;
    email: string;
    phone_number: string;
    address_line_1: string;
    address_line_2?: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
    extra_description: string;
    is_default: boolean;
    use_same_address?: boolean;
  };
}

export interface IAddAddressResponse extends IAddress {}

export interface IEditAddressPutRequestPayload {
  id: number;
  address_type: AddressType;
  body: {
    full_name?: string;
    email?: string;
    phone_number?: string;
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    state?: string;
    country?: string;
    postal_code?: string;
    extra_description?: string;
    is_default?: boolean;
  };
}

export interface IEditAddressPutResponse {
  id: number;
  address_type: AddressType;
  full_name: string;
  email: string;
  phone_number: string;
  address_line_1: string;
  address_line_2?: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  extra_description: string;
  created_at: string;
  is_default: boolean;
  customer: number;
}

export const AddressTypeMap: Record<AddressType, AddressType> = {
  SHIPPING: 'SHIPPING',
  BILLING: 'BILLING',
};